
import Vue from 'vue'
import { newSearch, focusFirstItem } from '../store/actions';

interface PaginationData {
	maxPagesVisible: number,
}

interface PaginationMethods {
    incrementPage(): void
	decrementPage(): void
	setPage(pageNumber: number): void
}

interface PaginationComputed {
    pages: number
	currentPage: number
	total: number
	assignmentsPerPage: number
	visiblePages: number | number[]
}

interface PaginationProps {}

export default Vue.extend<PaginationData, PaginationMethods, PaginationComputed, PaginationProps>({									
    name: 'PaginationComponent',
	data() {
		return {
			maxPagesVisible: 5
		}
	},
    computed: {
		pages() {
			return this.$store.getters.pages;
		},
		currentPage() {
			return this.$store.state.page
		},
		total() {
			return this.$store.state.total
		},
		assignmentsPerPage() {
			return this.$store.state.count
		},
		visiblePages() {
			const visiblePages = [];
			if(this.pages <= this.maxPagesVisible) {
				return this.pages;
			} else if(this.currentPage < this.maxPagesVisible - 1) {
				return this.maxPagesVisible - 1;
			} else if(this.currentPage > this.pages - 2) {
				for(let i = this.pages - 3; i <= this.pages; i++) {
					visiblePages.push(i);
				} 
			} else {
				for(let i = this.currentPage - 1; i < this.currentPage + 2; i++) {
					visiblePages.push(i);
				}
			}
			return visiblePages
		}
	},
	methods: {
		incrementPage() {
            this.$store.commit({
                type: 'setPage',
                payload: this.currentPage + 1,
            })
            this.$store.dispatch(newSearch(null));
			this.$store.dispatch(focusFirstItem(null));
		},
		decrementPage() {
            this.$store.commit({
                type: 'setPage',
                payload: this.currentPage - 1,
            })
            this.$store.dispatch(newSearch(null));
			this.$store.dispatch(focusFirstItem(null));
		},
		setPage(pageNumber) {
            this.$store.commit({
                type: 'setPage',
                payload: pageNumber,
            })
            this.$store.dispatch(newSearch(null));
			this.$store.dispatch(focusFirstItem(null));
		},
	},
})
